import {FC} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import {brandName, currentBrand, hasMegaPayBusinessCapabilities} from '../../_metronic/helpers/brand'

type MarkProps = {
  className?: string
  /** Accessible name; without it the mark is decorative. */
  title?: string
}

// The ASA mark as vectors, the same paths as asatsp.ir's AsaLogo: sharp at every size and no
// download (the logo files are 170–410 KB each).
const AsaMark: FC<MarkProps> = ({className, title}) => (
  <svg
    viewBox='0 0 1024 703'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    focusable='false'
    {...(title ? {role: 'img', 'aria-label': title} : {'aria-hidden': true})}
  >
    <path
      fill='#3b587d'
      d='M17.5 119.3 230.8 23.5 231 513A49.5 49.5 0 0 0 302.1 557.5L737 346V427.5L228.5 672.3A147 147 0 0 1 17.5 540Z'
    />
    <path fill='#3b587d' d='M790 254.3 1003.8 161.1V567A120 120 0 0 1 883.8 687H790Z' />
    <path
      fill='#3bb58f'
      d='M1003.8 15V96.5L365.3 397.2A40 40 0 0 1 308.3 361V87L343.3 65 346.8 311.5A6.1 6.1 0 0 0 355.5 317.1Z'
    />
  </svg>
)

// ASA's brands (megapay, asa) draw the vector mark; any other brand its own mark (the bank's install: MegaPay's).
const BrandMark: FC<MarkProps> = ({className, title}) =>
  hasMegaPayBusinessCapabilities() ? (
    <AsaMark className={className} title={title} />
  ) : (
    <img
      src={toAbsoluteUrl(currentBrand.mark || '/media/logos/default.svg')}
      alt={title || ''}
      className={className}
    />
  )

// The name beside the mark, as in the site's header: «معتمد آسا» for ASA's brands.
const brandLockupName = hasMegaPayBusinessCapabilities() ? 'معتمد آسا' : brandName

type LockupProps = {
  href: string
  /** A page of the panel instead (the header's logo goes to the dashboard, 2026-10-17). */
  to?: string
  className?: string
  /** Extra class for the name, e.g. Metronic's app-sidebar-logo-default to hide it when minimized. */
  nameClassName?: string
  newTab?: boolean
}

const BrandLockup: FC<LockupProps> = ({href, to, className, nameClassName, newTab = true}) =>
  to ? (
    <Link to={to} className={clsx('asa-brand-lockup', className)} aria-label={`داشبورد ${brandLockupName}`}>
      <BrandMark className='asa-brand-lockup__mark' />
      <span className={clsx('asa-brand-lockup__name', nameClassName)}>{brandLockupName}</span>
    </Link>
  ) : (
  <a
    href={href}
    className={clsx('asa-brand-lockup', className)}
    aria-label={`وب‌سایت ${brandLockupName}`}
    {...(newTab ? {target: '_blank', rel: 'noopener noreferrer'} : {})}
  >
    <BrandMark className='asa-brand-lockup__mark' />
    <span className={clsx('asa-brand-lockup__name', nameClassName)}>{brandLockupName}</span>
  </a>
  )

export {AsaMark, BrandMark, BrandLockup, brandLockupName}
